
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ScheduleSelector from './ScheduleSelector';
import { WEEK_DAYS } from '../utils/dates';

export default function Schedule(props) {
    const setDaySchedule = (value, index) => {
        props.setSchedule(prev => {
            let aux = [...prev]
            aux[index] = value
            return aux
        })
    }

    return (
        <Stack justifyContent='space-evenly' sx={{ width: '100%' }}>

            {!props.schedule ? null : props.schedule.map((value, index) => {
                return (
                    <div key={index} style={{ maxWidth: '400px', width: '100%', margin: 'auto' }}>
                        <Stack
                            direction='row'
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant='h6'>{WEEK_DAYS[index]}</Typography>

                            <Stack direction='row' alignItems='center' justifyContent='center' sx={{ m: 1 }} textAlign='right'>
                                {!value.active ? <span>Cerrado</span> : value.openAllDay ? <span>Abierto todo el dia</span> :
                                    <Stack>
                                        {value.time.map((time, i) => {
                                            return (
                                                <span key={i}>
                                                    {time.start.slice(0, 2) + ':' + time.start.slice(2,) + '-' + time.end.slice(0, 2) + ':' + time.end.slice(2,)}
                                                </span>
                                            )
                                        })}
                                    </Stack>
                                }

                                <ScheduleSelector
                                    day={value}
                                    setDaySchedule={(value) => setDaySchedule(value, index)}
                                />
                            </Stack>
                        </Stack>
                        <Divider />
                    </div>
                )
            })}
        </Stack>
    )
}